import { BaseService } from "./common/base";

export class SearchService extends BaseService<any> {
  constructor() {
    super("search");
  }
}
